// apolloClient.ts
import { ApolloClient, InMemoryCache, HttpLink } from '@apollo/client';
import { getGraphqlUri } from '../utils/config';
import { setContext } from '@apollo/client/link/context';

// Define the HTTP link
const httpLink = new HttpLink({
  uri: getGraphqlUri(),
});


// Middleware to add the token
const authLink = setContext((_, { headers }) => {
  const token = localStorage.getItem('authToken'); // Or wherever you store your token
  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : "",
    },
  };
});

// Initialize Apollo Client without caching
const graphqlApolloClient = new ApolloClient({
  link: authLink.concat(httpLink),
  cache: new InMemoryCache(),
  defaultOptions: {
    watchQuery: {
      fetchPolicy: 'no-cache',
    },
    query: {
      fetchPolicy: 'no-cache',
    },
    mutate: {
      fetchPolicy: 'no-cache',
    },
  },
});

export default graphqlApolloClient;
